import { createElement } from 'react';
var wrap = function () {
    var providers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        providers[_i] = arguments[_i];
    }
    return function (element) { return providers.reduceRight(function (element, provider) {
        var Provider, providerProps = {};
        if (Array.isArray(provider))
            Provider = provider[0], providerProps = provider[1];
        else
            Provider = provider;
        var wrap = createElement(Provider, providerProps, element);
        return wrap;
    }, element); };
};
export default wrap;
//# sourceMappingURL=wrap.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@hilma/tools/dist/react/wrap.js
// module id = 28
// module chunks = 1